import { render, staticRenderFns } from "./CharacterCounter.vue?vue&type=template&id=469d408e&"
import script from "./CharacterCounter.vue?vue&type=script&lang=js&"
export * from "./CharacterCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports